import fallbackImage from "@assets/images/fallback-game.svg";
import {useQuery} from "@tanstack/react-query";
import {useAuthStore} from "@/store/useAuth.store";
import {useGameMetadataStore} from "@/store/useGameMetadataStore";
import {recentGamesService} from "../../services/games/gamesList/recentGames.service";

export const useGetRecentGames = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const isAuthenticated = authStatus === "authenticated";
  const getGameById = useGameMetadataStore(state => state.getGameById);

  const {data, isPending, error} = useQuery({
    queryKey: ["recentGames"],
    queryFn: () => recentGamesService(),
    staleTime: 1000 * 60 * 5,
    enabled: isAuthenticated,
    select: responseData => {
      const gamesList = responseData?.data?.data || [];
      return gamesList.map((recentGame, index) => {
        const game = getGameById(recentGame.game_id, recentGame.game_provider);
        return {
          ...recentGame,
          icon: game?.icon || fallbackImage,
          provider: game?.provider || recentGame.game_provider,
          name: game?.name || recentGame.game_name || "Unknown Game",
          id: game?.id || recentGame.game_id,
          uniqueId: `${recentGame.game_id || "game"}-${recentGame.game_provider || "provider"}-${index}`,
        };
      });
    },
  });

  return {
    recentGames: data || [],
    isPending,
    error,
  };
};
